<template>

    <ButtonsIcon
        icon="mdi-plus"
        :color="color"
        @clicked="emit('clicked', $event)"
    />

</template>

<script setup>

import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    color: { type: String, default: 'primary' },
})

const emit = defineEmits(['clicked'])

</script>